export const getCategoryName = (
  categoryId: number | undefined,
  customerSetting: CustomerSetting
) => {
  const categoryName =
    customerSetting.categories.find((category) => category.id === categoryId)
      ?.name ?? '';
  return categoryName;
};
